const envJson = require('./env.json')


exports.configuration = {

    environment: envJson.VUE_APP_NODE_ENV,

    sentry: {

        sentryUrl: 'https://6aac7e5c95ba41da88463ea990329581@o1110212.ingest.sentry.io/6138933'

    },

    url: {

        baseUrl: envJson.VUE_APP_BASE_URL,
        server: envJson.VUE_APP_CLEANFOX_API_ROOT
    },

    front: {
        minimalAge: envJson.VUE_APP_MINIMAL_AGE,
        abTestingMaxDuration: envJson.VUE_APP_AB_TIMEOUT || 2000
    },

    email: {
        contact: 'support@cleanfox.io'
    },

    size: {
        tablet: 568,
        desktop: 800
    },

    tracking: {
        gtagId: envJson.VUE_APP_GTAG_ID,
        optimizeId: envJson.VUE_APP_OPTIMIZE_ID,
        amplitudeKey: envJson.VUE_APP_AMPLITUDE_KEY,
        smartBannerWebToken: envJson.VUE_APP_SMARTBANNER_WEB_TOKEN,
        adjustAppToken: envJson.VUE_APP_ADJUST_APP_TOKEN
    },

    languages: {
        all: [
            'ar-sa',
            'da-dk',
            'de-de',
            'en-gb',
            'es-es',
            'fr-fr',
            'hi-in',
            'it-it',
            'ja-jp',
            'nl-be',
            'nl-nl',
            'pl-pl',
            'pt-pt',
            'sv-se'
        ],
        backwardLanguage: {
            'ar': 'ar-sa',
            'da': 'da-dk',
            'de': 'de-de',
            'en': 'en-gb',
            'es': 'es-es',
            'fr': 'fr-fr',
            'hi': 'hi-in',
            'it': 'it-it',
            'ja': 'ja-jp',
            'nl': 'nl-nl',
            'pl': 'pl-pl',
            'pt': 'pt-pt',
            'sv': 'sv-se'
        },
        byName: {
            english: 'en',
            french: 'fr',
            german: 'de',
            arabe: 'ar'
        }
    },

    defaultLanguage: 'en-gb',

    defaultMetaLanguage: 'default',

    sharingCardsPositionDefault: [20, 60],
    
    firebaseConfig: {
        apiKey: envJson.VUE_APP_FIREBASE_API_KEY,
        authDomain: envJson.VUE_APP_FIREBASE_AUTH_DOMAIN,
        databaseURL: envJson.VUE_APP_FIREBASE_DATABASE_URL,
        projectId: envJson.VUE_APP_FIREBASE_PROJECT_ID,
        storageBucket: envJson.VUE_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: envJson.VUE_APP_FIREBASE_MESSAGIN_SENDER_ID,
        appId: envJson.VUE_APP_FIREBASE_APP_ID,
        measurementId: envJson.VUE_APP_FIREBASE_MEASURMENT_ID,
        cloudMessagingCertificat: envJson.VUE_APP_CERTIFICATS_WEB_PUSH
    },

    indexedDb: {
        name: 'cleanfox',
        version: 1
    }
}
